import { render, staticRenderFns } from "./shebei.vue?vue&type=template&id=5fdad53c&scoped=true"
import script from "./shebei.vue?vue&type=script&lang=js"
export * from "./shebei.vue?vue&type=script&lang=js"
import style0 from "./shebei.vue?vue&type=style&index=0&id=5fdad53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdad53c",
  null
  
)

export default component.exports